import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import red from '@mui/material/colors/red';
import green from '@mui/material/colors/green';

import * as ROUTES from '../../constants/routes';
import { _lt } from '../../localization/locale';
import { getImage } from '../../utils/images';

import { getRequest, postJSONRequest } from '../../utils/requests';
import { handleAPIError } from '../../utils/apiResponeHandler';
import { gt_config } from '../../configs';
import { Button, Divider } from '@mui/material/';
import { useTheme } from '@mui/material/styles';

const PendingInvitesList = (props) => {
  const theme = useTheme();

  const classes = {
    root: {
      height: 'calc(100vh - 2rem)',
      display: 'flex',
      justifyContent: 'center',
    },
    contentWrapper: {
      width: '100%',
      maxWidth: '600px',
      height: 'max-content',
      margin: '80px 16px 16px',
      padding: '24px',
      [theme.breakpoints.down('xs')]: {
        margin: '80px 0 0',
        borderRadius: '0',
      },
    },
    list: {
      margin: '16px 0 0',
      padding: '0',
      paddingBottom: '16px',
      minWidth: '300px',
      borderBottom: '1px solid #ddd',
    },
    paper: {
      textAlign: 'right',
      background: 'transparent',
    },
  };

  const [loading, setLoading] = useState(true);
  const [skip, setSkip] = useState(true);
  const [pendingInvites, setPendingInvites] = useState(null);

  useEffect(() => {
    fetchPendingInvites();
  }, []);

  const fetchPendingInvites = async () => {
    try {
      const response = await fetch(
        getRequest(`${gt_config.urls.networking}invites`),
      );
      const res = await handleAPIError(response);
      const json = await res.json();
      if (json.data.length > 0) {
        setLoading(false);
        setPendingInvites(json.data);
      } else {
        //props.history.push(ROUTES.SIGN_UP_ONBOARD_BRANCH);
        props.history.push(ROUTES.HOME);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
      //props.history.push(ROUTES.SIGN_UP_ONBOARD_BRANCH);
      props.history.push(ROUTES.HOME);
    }
  };

  const acceptInvite = async (invite, index) => {
    try {
      const response = await fetch(
        postJSONRequest(`${gt_config.urls.networking}process_invite`, {
          token: invite.token,
        }),
      );
      const res = await handleAPIError(response);
      const json = await res.json();
      if (json.status) {
        const originalInvites = [...pendingInvites];
        originalInvites[index]['accepted'] = true;
        setPendingInvites(originalInvites);
        setSkip(false);
      }
    } catch (error) {
      // do nothing
      console.error(error);
    }
  };

  return (
    <Box sx={classes.root}>
      <Paper elevation={0} sx={classes.contentWrapper}>
        <Grid spacing={1} direction="row" container>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              {_lt('Your pending invitations to Global Talent')}
            </Typography>
            <Typography variant="subtitle" gutterBottom>
              {_lt('Press the tick icon to accept')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <List>
              {pendingInvites &&
                pendingInvites.map((x, i) => (
                  <ListItem alignItems="flex-start" sx={classes.list}>
                    <ListItemAvatar>
                      <Avatar
                        alt={x.name}
                        sx={{ border: '1px solid gainsboro' }}
                        src={getImage(x)}
                      />
                    </ListItemAvatar>
                    <ListItemText primary={x.name} secondary={x.extra} />
                    {!x.accepted && (
                      <Tooltip title={_lt('Accept')}>
                        <IconButton
                          aria-label={_lt('Accept')}
                          style={{ color: red[500] }}
                          onClick={() => acceptInvite(x, i)}
                        >
                          <CheckCircleIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                    {x.accepted && (
                      <Tooltip title={_lt('Accepted')}>
                        <IconButton
                          aria-label={_lt('Accepted')}
                          style={{ color: green[500] }}
                          disabled
                        >
                          <CheckCircleIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </ListItem>
                ))}
            </List>
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={0} sx={classes.paper}>
              {skip && (
                <Button
                  variant="outlined"
                  component={RouterLink}
                  to={{
                    pathname: ROUTES.HOME,
                    state: { from: props.location },
                  }}
                  color="inherit"
                >
                  {_lt('Skip')}
                </Button>
              )}
              {!skip && (
                <Button
                  variant="outlined"
                  component={RouterLink}
                  to={{
                    pathname: ROUTES.HOME,
                    state: { from: props.location },
                  }}
                  color="inherit"
                >
                  {_lt('Next')}
                </Button>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  userInfo: state.user.info,
});

const mapDispatchToProps = {};

const PendingInvites = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PendingInvitesList),
);

export default PendingInvites;
